export const hover = '#1EC3AA';
export const darkGreen = '#008C44';
export const lightGreen = '#21FF8D';
export const font = 'Poppins';


